/** Auto-generated Indian bank names (from razorpay/ifsc banknames). */
export const INDIAN_BANKS = [
  "510 Army Base W/s Credit Co-operative Primary Bank",
  "A.P. Mahesh Co-operative Urban Bank",
  "A.P. Raja Rajeswari Mahila Co-operative Urban Bank",
  "AB Bank",
  "Abhinandan Urban Co-operative Bank Amravati",
  "Abhinav Sahakari Bank",
  "Abhyudaya Co-operative Bank",
  "Abu Dhabi Commercial Bank",
  "Ace Co-operative Bank",
  "Adarsh Co-operative Bank",
  "Adarsh Co-operative Urban Bank",
  "Adarsh Mahila Mercantile Co-operative Bank",
  "Adilabad District Co-operative Central Bank",
  "Adinath Co-operative Bank",
  "Aditya Birla Idea Payments Bank",
  "Adv. Shamraoji Shinde Satyashodhak Bank",
  "Agartala Co-operative Urban Bank",
  "Agra District Co-operative Bank",
  "Agrasen Co-operative Urban Bank",
  "Agrasen Nagari Sahakari Bank",
  "Agroha Co-operative Urban Bank",
  "Ahilyadevi Urban Co-operative Bank Solapur",
  "Ahmedabad District Co-operative Bank",
  "Ahmedabad Mercantile Co-operative Bank",
  "Ahmednagar District Central Co-operative Bank",
  "Ahmednagar Merchant's Co-operative Bank",
  "Ahmednagar Merchants Co-operative Bank",
  "Ahmednagar Shahar Sahakari Bank Maryadit",
  "Airtel Payments Bank",
  "Ajantha Urban Co-operative Bank",
  "Ajara Urban Co-operative Bank",
  "Ajmer Central Co-operative Bank",
  "Akhand Anand Co.op Bank",
  "Akkamahadevi Mahila Sahakari Bank Niyamit",
  "Akola District Central Co-operative Bank",
  "Akola Janata Commercial Co-operative Bank",
  "Akola Merchant Co-operative Bank",
  "Akola Urban Co-operative Bank",
  "Alappuzha District Co-operative Bank",
  "Alavi Co-operative Bank",
  "Aligarh District Co-operative Bank",
  "Allahabad Bank",
  "Allahabad District Co-operative Bank",
  "Allahabad Up Gramin Bank",
  "Almora Urban Co-operative Bank",
  "Almora Zila d Bank",
  "Alwar Central Co-operative Bank",
  "Alwar Urban Co-operative Bank",
  "Alwaye Urban Co-operative Bank",
  "Aman Sahakari Bank",
  "Amarnath Co-operative Bank",
  "Ambajogai Peoples Co-operative Bank",
  "Ambala Central Co-operative Bank",
  "Ambarnath Jai-hind Co-operative Bank",
  "Ambika Mahila Sahakari Bank",
  "Amravati District Central Co-operative Bank",
  "Amravati Zilla Parishad Shikshak Sahakari Bank",
  "Amreli Jilla Madhyastha Sahakari Bank",
  "Amreli Nagarik Sahakari Bank",
  "Amritsar Central Co-operative Bank",
  "Anand Mercantile Co-operative Bank",
  "Anantapur District Co-operative Central Bank",
  "Andaman & Nicobar State Co-operative Bank",
  "Andarsul Urban Co-operative Bank",
  "Andhra Bank",
  "Andhra Bank Employees Co-operative Bank",
  "Andhra Pradesh Grameena Vikas Bank",
  "Andhra Pradesh State Co-operative Bank",
  "Andhra Pragathi Grameena Bank",
  "Angul United Central Co-operative Bank",
  "Ankola Urban Co-operative Bank",
  "Annasaheb Chougule Urban Co-operative Bank",
  "Annasaheb Magar Sahakari Bank",
  "Annasaheb Savant Co-operative Urban Bank Mahad",
  "Anuradha Urban Co-operative Bank",
  "Ap Janata Co-operative Urban Bank",
  "Ap Mahajan's Co-operative Urban Bank",
  "Apani Sahakari Bank",
  "Apna Sahakari Bank",
  "Arunachal Pradesh Rural Bank",
  "Arunachal Pradesh State Co-operative Apex Bank",
  "Arvind Sahakari Bank",
  "Aryapuram Co-operative Urban Bank",
  "Ashok Sahakari Bank",
  "Ashoknagar Co-operative Bank",
  "Ashta People's Co-operative Bank",
  "Aska Co-operative Central Bank",
  "Assam Co-operative Apex Bank",
  "Assam Gramin Vikash Bank",
  "Associate Co-operative Bank",
  "Astha Mahila Nagrik Sahakari Bank Maryadit",
  "AU Small Finance Bank",
  "Aurangabad District Central Co-operative Bank",
  "Aurangabad District Central Co-operative Bank. Bihar",
  "Australia and New Zealand Banking Group",
  "Axis Bank",
  "Azad Co-operative Bank",
  "Azad Urban Co-operative Bank Hubli",
  "Badagara Co-operative Urban Bank",
  "Badaun Zila d Bank",
  "Bagalkot District Central Co-operative Bank",
  "Baghat Urban Co-operative Bank",
  "Bahraich District Co-operative Bank",
  "Baidyabati Sheoraphuli Co-operative Bank",
  "Balageria Central Co-operative Bank",
  "Balangir District Central Co-operative Bank",
  "Balasinor Nagarik Sahakari Bank",
  "Balasore Bhadrak Central Co-operative Bank",
  "Balitikuri Co-operative Bank",
  "Bally Co-operative Bank",
  "Balotra Urban Co-operative Bank",
  "Balusseri Co-operative Urban Bank",
  "Banaras Mercantile Co-operative Bank",
  "Banaskantha District Central Co-operative Bank",
  "Banaskantha Mercantile Co-operative Bank",
  "Banda District Co-operative Bank",
  "Banda Urban Co-operative Bank",
  "Bandhan Bank",
  "Bangalore  Bangalore Rural&ramanagara Dccb",
  "Bangalore City Co-operative Bank",
  "Bangiya Gramin Vikash Bank",
  "Bank of America",
  "Bank of Bahrein and Kuwait",
  "Bank of Baroda",
  "Bank of Ceylon",
  "Bank of India",
  "Bank of Maharashtra",
  "Bank of Nova Scotia",
  "Banki Central Co-operative Bank",
  "Bankura District Central Co-operative Bank",
  "Banswara Central Co-operative Bank",
  "Bantra Co-operative Bank",
  "Bapuji Co-operative Bank",
  "Bapunagar Mahila Co-operative Bank",
  "Baramati Sahakari Bank",
  "Baran Kendriya Sahakari Bank Baran",
  "Baran Nagrik Bank",
  "Barclays Bank",
  "Barmer Central Co-operative Bank",
  "Baroda Central Co-operative Bank",
  "Baroda City Co-operative Bank",
  "Baroda Gujarat Gramin Bank",
  "Baroda Rajasthan Kshetriya Gramin Bank",
  "Baroda Traders Co-operative Bank",
  "Baroda Uttar Pradesh Gramin Bank",
  "Bassein Catholic Co-operative Bank",
  "Bathinda Central Co-operative Bank",
  "Bavla Nagrik Sahakari Bank",
  "Beawar Urban Co-operative Bank",
  "Becharaji Nagarik Sahakari Bank",
  "Beed District Central Co-operative Bank",
  "Begusarai Central Co-operative Bank",
  "Belgaum District Central Co-operative Bank",
  "Bellad Bagewadi Urban Souharada Sahakari Bank Nyt",
  "Bellary District Co-operative Central Bank",
  "Belur Urban Co-operative Bank",
  "Berhampore Co-operative Central Bank",
  "Betul Nagrik Sahakari Bank Mydt",
  "Bhabhar Vibhag Nagrik Sahakari Bank",
  "Bhadgaon People's Co-operative Bank",
  "Bhadohi Urban Co-operative Bank Gyanpur",
  "Bhadradri Co-operative Urban Bank",
  "Bhadran People's Co-operative Bank",
  "Bhagalpur Central Co-operative Bank",
  "Bhagini Nivedita Sahakari Bank",
  "Bhagini Nivedita Sahakari Bank Pune",
  "Bhagyalakshmi Mahila Sahakari Bank",
  "Bhagyodaya Co-operative Bank",
  "Bhagyodaya Friends Urban Co-operative Bank",
  "Bhandara District Central Co-operative Bank",
  "Bhandara Urban Co-operative Bank",
  "Bharat Co-operative Bank",
  "Bharath Co-operative Bank",
  "Bharati Sahakari Bank",
  "Bharatiya Mahila Bank",
  "Bharatpur Central Co-operative Bank",
  "Bharuch District Central Co-operative Bank Bharuc",
  "Bhatkal Urban Co-operative Bank",
  "Bhatpara Naihati Co-operative Bank",
  "Bhavana Rishi Co-operative Urban Bank",
  "Bhavani Sahakari Bank",
  "Bhavasara Kshatriya Co-operative Bank",
  "Bhavnagar District Co-operative Bank",
  "Bhawanipatna Central Co-operative Bank",
  "Bhel Employees Co-operative Bank",
  "Bhilai Nagarik Sahakari Bank Maryadit",
  "Bhilwara Mahila Urban Co-operative Bank",
  "Bhilwara Urban Co-operative Bank",
  "Bhind Nagrik Sahakari Bank Mydt",
  "Bhingar Urban Co-operative Bank",
  "Bhiwani Central Co-operative Bank Bhiwani",
  "Bhopal Co-operative Central Bank",
  "Bhuj Commercial Co-operative Bank",
  "Bhuj Mercentile Co-operative Bank",
  "Bicholim Urban Co-operative Bank",
  "Bihar Awami Co-operative Bank",
  "Bihar State Co-operative Bank",
  "Bijapur District Central Co-operative Bank",
  "Bijnor Urban Co-operative Bank",
  "Bilagi Pattana Sahakari Bank Niyamit",
  "Birbhum District Central Co-operative Bank",
  "BNP Paribas Bank",
  "Bombay Mercantile Co-operative Bank",
  "Boral Union Co-operative Bank",
  "Botad Peoples Co-operative Bank",
  "Boudh Co-operative Central Bank",
  "Brahmadeodada Mane Sahakari Bank Solapur",
  "Brahmawart Commercial Co-operative Bank",
  "Bramhapuri Urban Co-operative Bank",
  "Buldana District Central Co-operative Bank",
  "Bundi Central Co-operative Bank",
  "Burdwan Central Co-operative Bank",
  "Business Co-operative Bank",
  "Calicut Co-operative Urban Bank",
  "Canara Bank",
  "Capital Small Finance Bank",
  "Catholic Co-operative Urban Bank",
  "Catholic Syrian Bank",
  "Central Bank of India",
  "Central Co-operative Bank  Bhilwara",
  "Central Co-operative Bank Ara",
  "Central Co-operative Bank Bikaner",
  "Central Co-operative Bank Tonk",
  "Central Madhya Pradesh Gramin Bank",
  "Chaitanya Godavari Grameena Bank",
  "Chaitanya Mahila Sahakari Bank, Vijayapur",
  "Chamba Urban Co-operative Bank Chamba",
  "Chamoli Zila d Bank",
  "Chanasma Commercial Co-operative Bank",
  "Chandigarh State Co-operative Bank",
  "Chandrapur District Central Co-operative Bank",
  "Chartered Sahakari Bank Niyamitha",
  "Chembur Nagarik Sahakari Bank",
  "Chengelpattu Co-operative Urban Bank",
  "Chennai Central Co-operative Bank",
  "Cherpalcheri Co-operative Urban Bank",
  "Chhattisgarh Rajya Gramin Bank",
  "Chhattisgarh Rajya Sahakari Bank Mydt",
  "Chikhli Urban Co-operative Bank",
  "Chikmagalur District Central Co-operative Bank",
  "Chikmagalur Pattana Sahakara Bank Niyamitha",
  "Chinatrust Commercial Bank",
  "Chiplun Urban Co-operative Bank",
  "Chitnavispura Sahakari Bank",
  "Chitradurga District Co-operative Central Bank",
  "Chittoor District Co-operative Central Bank",
  "Chittorgarh Kendriya Sahakari Bank",
  "Chittorgarh Urban Co-operative Bank",
  "Chopda Peoples Co-operative Bank",
  "Churu Central Co-operative Bank",
  "Churu Zila Urban Co-operative Bank",
  "CITI Bank",
  "Citizen Co-operative Bank",
  "Citizen Credit Co-operative Bank",
  "Citizens Co-operative Bank",
  "Citizens Urban Co-operative Bank",
  "Citizens' Co-operative Bank Jammu",
  "City Co-operative Bank",
  "City Union Bank",
  "Co-operative Bank of Mehsana",
  "Co-operative Bank of Rajkot",
  "Co-operative City Bank",
  "Coastal Local Area Bank",
  "Coimbatore District Central Co-operative Bank",
  "Col Rd Nikam Sainik Sahakari Bank",
  "Colour Merchant's Co-operative Bank",
  "Commercial Co-operative Bank",
  "Commonwealth Bank of Australia",
  "Contai Co-operative Bank",
  "Corporation Bank",
  "Cosmos Co-operative Bank",
  "Credit Agricole Corporate and Investment Bank",
  "Credit Suisse AG",
  "Cuddalore District Central Co-operative Bank",
  "Cuttack Central Co-operative Bank",
  "D.y.patil Sahakari Bank Kolhapur",
  "Dahod Mercantile Co-operative Bank",
  "Dahod Urban Co-operative Bank",
  "Daivadnya Sahakara Bank Niyamit",
  "Dakshin Bihar Gramin Bank",
  "Dakshin Dinajpur District Central Co-operative Bank",
  "Dapoli Urban Co-operative Bank",
  "Darjeeling District Central Co-operative Bank",
  "Darussalam Co-operative Urban Bank",
  "Dattatraya Maharaj Kalambe Jaoli Sahakari Bank",
  "Daund Urban Co-operative Bank",
  "Dausa Kendriya Bank",
  "Dausa Urban Co-operative Bank",
  "Davanagere District Central Co-operative Bank",
  "DCB Bank",
  "Deccan Co-operative Urban Bank",
  "Deccan Merchants Co-operative Bank",
  "Deendayal Nagari Sahakari Bank",
  "Defence Accounts Co-operative Bank",
  "Dehradun District Co-operative Bank",
  "Delhi Nagrik Sehkari Bank",
  "Delhi State Co-operative Bank",
  "Dena Bank",
  "Dena Gujarat Gramin Bank",
  "Deoghar Jamtara Central Co-operative Bank Deoghar",
  "Deogiri Nagari Sahakari Bank Aurangabad",
  "Deogiri Sahakari Bank Aurangabad",
  "Deoria Kasia District Co-operative Bank",
  "Deposit Insurance and Credit Guarantee Corporation",
  "Deutsche Bank",
  "Development Bank of Singapore",
  "Development Co-operative Bank Kanpur",
  "Devika Urban Co-operative Bank",
  "Dhakuria Co-operative Bank",
  "Dhanbad Central Co-operative Bank",
  "Dhanera Mercantile Co-operative Bank",
  "Dhanlaxmi Bank",
  "Dharamvir Sambhaji Urban Co-operative Bank",
  "Dharmapuri District Central Co-operative Bank",
  "Dhule And Nandurbar District Central Co-operative Bank",
  "Dilip Urban Co-operative Bank",
  "Dindigul Central Co-operative Bank",
  "District Central Co-operative Bank Elluru",
  "District Central Co-operative Bank Khammam",
  "District Central Co-operative Bank, Supaul",
  "District Co-operative Bank Barabanki",
  "District Co-operative Bank Faizabad",
  "District Co-operative Bank Mainpuri",
  "District Co-operative Bank Pilibhit",
  "District Co-operative Bank Pratapgarh",
  "District Co-operative Bank Rae Bareli",
  "District Co-operative Bank Saharanpur",
  "District Co-operative Bank Shahjahanpur",
  "District Co-operative Bank Teliyabagh",
  "District Co-operative Bank, Sitapur",
  "District Co-operative Central Bank",
  "District Co-operative Central Bank Kakinada",
  "District Co-operative Central Bank Kurnool",
  "District Co-operative Central Bank Mahabubnagar",
  "District Co-operative Central Bank Srikakul",
  "District Co-operative Central Bank Visakhapatnam",
  "District Co-operative Central Bank Vizianagaram",
  "Dmk Jaoli Bank",
  "Doha Bank QSC",
  "Dombivli Nagari Sahakari Bank",
  "Dr Babasaheb Ambedkar Sahakari Bank Nasik",
  "Dr. Ambedkar Nagrik Sahakari Bank Mydt Gwalior",
  "Dumka Central Co-operative Bank",
  "Dungarpur Central Co-operative Bank",
  "Durg Rajnandgaon Gramin Bank",
  "Durgapur Mahila Co-operative Bank",
  "Durgapur Steel Peoples Co-operative Bank",
  "Durgapur Steel Peoples' Co-operative Bank",
  "Eenadu Co-operative Urban Bank",
  "Ellaquai Dehati Bank",
  "Emirates NBD Bank",
  "Equitas Small Finance Bank",
  "Ernakulam District Co-operative Bank",
  "Erode District Central Co-operative Bank",
  "Esaf Small Finance Bank",
  "ESAF Small Finance Bank",
  "Etah District Co-operative Bank",
  "Etah Urban Co-operative Bank",
  "Etawah District Co-operative Bank Etwah",
  "Etawah Urban Co-operative Bank Etawah",
  "Excellent Co-operative Bank",
  "Export Import Bank of India",
  "Faiz Mercantile Co-operative Bank, Nasik",
  "Faridabad Central Co-operative Bank",
  "Faridkot Central Co-operative Bank",
  "Farrukhabad District Co-operative Bank Fatehgarh",
  "Fatehabad Central Co-operative Bank",
  "Fatehgrah Sahib Central Co-operative Bank",
  "Fazilka Central Co-operative. Bank",
  "Federal Bank",
  "Feroke Co-operative Bank",
  "Ferozepur Central Co-operative. Bank",
  "Financial Co-operative Bank",
  "Fincare Small Finance Bank",
  "Fingrowth Co-operative Bank",
  "Fino Payments Bank",
  "Firozabad Zila d Bank",
  "Firstrand Bank",
  "Gadchiroli District Central Co-operative Bank",
  "Gadhinglaj Urban Co-operative Bank",
  "Gandevi People's Co-operative Bank",
  "Gandhi Co-operative Urban Bank",
  "Gandhibag Sahakari Bank  Nagpur",
  "Gandhidham Co-operative Bank",
  "Gandhidham Mercantile Co-operative Bank",
  "Gandhinagar Nagrik Co-operative Bank",
  "Gandhinagar Urban Co-operative Bank",
  "Ganga Mercantile Urban Co-operative Bank",
  "Ganganagar Kendriya Sahakari Bank",
  "Gauhati Co-operative Urban Bank",
  "Gayatri Co-operative Urban Bank",
  "General Post Office",
  "George Town Co-operative Bank",
  "Ghatal Peoples' Co-operative Bank",
  "Giridih Central Co-operative Bank",
  "Goa State Co-operative Bank",
  "Goa Urban Co-operative Bank",
  "Godavari Urban Co-operative Bank",
  "Godavari Urban Co-operative Bank Nashik",
  "Godhra Urban Co-operative Bank",
  "Gokak Urban Co-operative Credit Bank",
  "Gondal Nagarik Sahakari Bank",
  "Gondia District Central Co-operative Bank Gondia",
  "Gopalganj Central Co-operative Bank",
  "Gopinath Patil Parsik Janata Sahakari Bank",
  "Gozaria Nagrik Sahakari Bank",
  "Grain Merchants' Co-operative Bank",
  "Gramin Bank of Aryavart",
  "Greater Bombay Co-operative Bank",
  "Guardian Souharda Sahakari Bank Niyamita",
  "Gujarat Ambuja Co-operative Bank",
  "Gujarat Mercantile Co-operative Bank",
  "Gujarat State Co-operative Bank",
  "Gulshan Mercantile Urban Co-operative Bank",
  "Gumla Simdega Central Co-operative Bank",
  "Guntur Co-operative Urban Bank",
  "Guntur District Co-operative Central Bank",
  "Gurdaspur Central Co-operative Bank",
  "Gurgaon Central Co-operative Bank",
  "Gurgaon Gramin Bank",
  "Guruvayur Co-operative Urban Bank",
  "Hadagali Urban Co-operative Bank",
  "Halol Mercantile Co-operative Bank",
  "Hamirpur District Co-operative Bank",
  "Hanamasagar Urban Co-operative Bank",
  "Hanumangarh Kendriya Sahakari Bank",
  "Hardoi District Co-operative Bank",
  "Harihareshwar Sahakari Bank",
  "Haryana State Co-operative Apex Bank",
  "Hassan District Co-operative Central Bank",
  "Hasti Co-operative Bank",
  "HASTI Co-operative Bank",
  "Haveli Sahakari Bank",
  "Hazaribag Central Co-operative Bank",
  "HCBL Co-operative Bank",
  "HDFC Bank",
  "Himachal Pradesh Gramin Bank",
  "Himachal Pradesh State Co-operative Bank",
  "Himatnagar Nagarik Sahakari Bank",
  "Hindu Co-operative Bank",
  "Hindustan Shipyard Staff Co-operative Bank",
  "Hisar Central Co-operative Bank Hisar",
  "Hissar Urban Co-operative Bank",
  "Hongkong & Shanghai Banking Corporation",
  "Hooghly Co-operative Credit Bank",
  "Hooghly District Central Co-operative Bank",
  "Hoshiarpur Central Co-operative Bank",
  "Howrah District Central Co-operative Bank",
  "HSBC Bank Oman S.A.O.G",
  "Hubli Urban Co-operative Bank",
  "Hutatma Sahakari Bank",
  "Hyderabad District Co-operative Bank",
  "Ichalkaranji Merchants Co-operative Bank",
  "ICICI Bank",
  "IDBI",
  "IDFC FIRST Bank",
  "IDRBT",
  "Idukki District Co-operative Bank",
  "Ilkal Co-operative Bank",
  "Imperial Urban Co-operative Bank",
  "Imperial Urban Co-operative Bank Jalandhar",
  "Imphal Urban Co-operative Bank",
  "Income Tax Dept Co-operative Bank",
  "Indapur Urban Co-operative Bank",
  "Independence Co-operative Bank",
  "India Post Payments Bank",
  "Indian Bank",
  "Indian Clearing Corporation",
  "Indian Overseas Bank",
  "Indore Cloth Market Co-operative Bank",
  "Indore Paraspar Sahakari Bank",
  "Indore Premier Co-operative Bank",
  "Indore Swayam Mahila Co-operative Bank",
  "Indraprastha Sehkari Bank",
  "Indrayani Co-operative Bank",
  "Indusind Bank",
  "Industrial and Commercial Bank of China",
  "Industrial Bank of Korea",
  "Industrial Co-operative Bank",
  "ING Vysya Bank",
  "Integral Urban Co-operative Bank",
  "Irinjalakuda Town Co-operative Bank",
  "J&K Grameen Bank",
  "J&k State Co-operative Bank",
  "Jagruti Co-operative Urban Bank",
  "Jaihind Urban Co-operative Bank",
  "Jain Co-operative Bank",
  "Jain Sahakari Bank",
  "Jaipur Central Co-operative Bank",
  "Jaisalmer Central Co-operative Bank",
  "Jalandhar Central Co-operative Bank",
  "Jalaun District Co-operative Bank",
  "Jalgaon District Central Co-operative Bank Jalgaon",
  "Jalgaon Janata Bank",
  "Jalgaon Peoples Co-operative Bank",
  "Jalna District Central Co-operative Bank",
  "Jalna Merchants Co-operative Bank",
  "Jalna Peoples Co-operative Bank Jalna",
  "Jalore Central Co-operative Bank Jalore",
  "Jalore Nagrik Sahakari Bank",
  "Jalpaiguri Central Co-operative Bank",
  "Jamia Co-operative Bank",
  "Jammu and Kashmir Bank",
  "Jammu Central Co-operative Bank",
  "Jamnagar District Co-operative Bank",
  "Jamnagar Mahila Sahakari Bank",
  "Jamnagar Peoples Co-operative Bank",
  "Jampeta Co-Operative Urban Bank",
  "Jamshedpur Urban Co-operative Bank",
  "Jana Small Finance Bank",
  "Janakalyan Co-operative Bank Nashik",
  "Janakalyan Sahakari Bank",
  "Janalaxmi Co-operative Bank",
  "Janaseva Co-operative Bank (Nashik)",
  "Janaseva Sahakari Bank (Borivli)",
  "Janaseva Sahakari Bank, Pune",
  "Janata Co-operative Bank",
  "Janata Co-operative Bank Malegaon.",
  "Janata Co-operative Bank Sadalga",
  "Janata Sahakari Bank (Pune)",
  "Janata Sahakari Bank Ajara",
  "Janata Sahakari Bank Amravati",
  "Janatha Seva Co-operative Bank",
  "Janseva Nagari Sahakari Bank Marydit",
  "Jansewa Urban Co-operative Bank",
  "Jaynagar Mozilpur Peoples Co-operative Bank",
  "Jaysingpur Udgaon Sahakari Bank Jaysingpur",
  "Jhajjar Central Co-operative Bank",
  "Jhalawar Kendriya Bank",
  "Jhalawar Nagrik Sahakari Bank",
  "Jharkand Gramin Bank",
  "Jharkhand Rajya Gramin Bank",
  "Jharkhand State Co-operative Bank",
  "Jharneshwar Nagrik Sahakari Bank Maryadit",
  "Jhunjhunu Kenddriya Sahakari Bak",
  "Jijamata Mahila Sahakari Bank",
  "Jila d Kendriya Bank Maryadit Bilaspur",
  "Jila d Kendriya Bank Mydt Damoh",
  "Jila d Kendriya Bank Mydt Datia",
  "Jila d Kendriya Bank Mydt Jhabua",
  "Jila Kendriya Bank Maryadit Khargone",
  "Jila Sahakari Bank Mydt. Gwalior",
  "Jila Sahakari Kendariya Bank Mydt Khandwa",
  "Jila Sahakari Kendriya Bank Maryadit Balaghat",
  "Jila Sahakari Kendriya Bank Maryadit Betul",
  "Jila Sahakari Kendriya Bank Maryadit Bhind",
  "Jila Sahakari Kendriya Bank Maryadit Chhindwara",
  "Jila Sahakari Kendriya Bank Maryadit Jagdalpur",
  "Jila Sahakari Kendriya Bank Maryadit Raipur",
  "Jila Sahakari Kendriya Bank Maryadit Rajgarh",
  "Jila Sahakari Kendriya Bank Maryadit Rajnandgaon",
  "Jila Sahakari Kendriya Bank Maryadit Sagar",
  "Jila Sahakari Kendriya Bank Maryadit Shivpuri",
  "Jila Sahakari Kendriya Bank Maryadit Sidhi",
  "Jila Sahakari Kendriya Bank Mydt Ambikapur",
  "Jila Sahakari Kendriya Bank Mydt Chhatarpur",
  "Jila Sahakari Kendriya Bank Mydt Dhar",
  "Jila Sahakari Kendriya Bank Mydt Durg",
  "Jila Sahakari Kendriya Bank Mydt Guna",
  "Jila Sahakari Kendriya Bank Mydt Hoshangabad",
  "Jila Sahakari Kendriya Bank Mydt Mandla",
  "Jila Sahakari Kendriya Bank Mydt Mandsaur",
  "Jila Sahakari Kendriya Bank Mydt Morena",
  "Jila Sahakari Kendriya Bank Mydt Narsinghpur",
  "Jila Sahakari Kendriya Bank Mydt Panna",
  "Jila Sahakari Kendriya Bank Mydt Ratlam",
  "Jila Sahakari Kendriya Bank Mydt Rewa",
  "Jila Sahakari Kendriya Bank Mydt Satna",
  "Jila Sahakari Kendriya Bank Mydt Sehore",
  "Jila Sahakari Kendriya Bank Mydt Shahdol",
  "Jila Sahakari Kendriya Bank Mydt Shajapur",
  "Jila Sahakari Kendriya Bank Mydt Tikamgarh",
  "Jila Sahakari Kendriya Bank Mydt Ujjain",
  "Jila Sahakari Kendriya Bank Mydt Vidisha",
  "Jila Sahakari Kendriya Bank Mydt. Jabalpur",
  "Jila Sahakari Kendriya Bank Mydtt Dewas",
  "Jila Sahakari Kendriya Bank Myt Seoni",
  "Jilla Sahakari Kendriya Bank Mydt Raisen",
  "Jind Central Co-operative Bank",
  "Jio Payments Bank",
  "Jivaji Sahakari Bank  Ichalkaranji",
  "Jivan Commercial Co-operative Bank",
  "Jodhpur Central Co-operative Bank",
  "Jodhpur Nagrik Sahakari Bank",
  "Jogindra Central Co-operative Bank",
  "Jowai Co-operative Urban Bank",
  "JP Morgan Chase Bank NA",
  "Jugalkishor Tapdiya Shree Mahesh Ucb Aurangabadltd",
  "Junagadh Commercial Co-operative Bank",
  "Junagadh Jilla Sahakari Bank",
  "Kachchh District Central Co-operative Bank",
  "Kadappa District Co-operative Central Bank",
  "Kaduthuruthy Urban Co-operative Bank",
  "Kagal Co-operative Bank Kagal",
  "Kaira District Central Co-operative Bank",
  "Kaithal Central Co-operative Bank",
  "Kakatiya Co-operative Urban Bank",
  "Kalaburagi and Yadgir District Co-operative Central Bank",
  "Kallappanna Awade Ichalkaranji Janata Sahakari Bank",
  "Kalna Town Credit Co-operative Bank",
  "Kalol Nagarik Sahakari Bank",
  "Kalupur Commercial Co-operative Bank",
  "Kalyan Janata Sahakari Bank",
  "Kamala Co-operative Bank Solapur",
  "Kanakamahalakshmi Co-operative Bank",
  "Kanara District Central Co-operative Bank",
  "Kancheepuram Central Co-operative Bank",
  "Kangra Central Co-operative Bank",
  "Kangra Co-operative Bank",
  "Kankaria Mainagar Nagrik Sahakari Bank",
  "Kannur Co-operative Urban Bank",
  "Kannur District Co-operative Bank",
  "Kanyakumari District Central Co-operative Bank",
  "Kapol Co-operative Bank",
  "Kapurthala Central Co-operative Bank",
  "Karad Janata Sahakari Bank",
  "Karad Urban Co-operative Bank",
  "Karamana Co-operative Urban Bank",
  "Karan Urban Co-operative Bank",
  "Karimnagar District Co-operative Central Bank",
  "Karjan Nagrik Sahakari Bank",
  "Karnal Central Co-operative Bank",
  "Karnala Nagari Sahakari Bank Panvel",
  "Karnatak Central Co-operative Bank Dharwad",
  "Karnataka Bank",
  "Karnataka Gramin Bank",
  "Karnataka Mahila Sahakari Bank",
  "Karnataka State Co-operative Apex Bank",
  "Karnataka Vikas Grameena Bank",
  "Karnavati Co-operative Bank",
  "Karur Vysya Bank",
  "Kasaragod Co-operative Town Bank No 970",
  "Kasaragod District Co-operative Bank",
  "Kashi Gomti Samyut Gramin Bank",
  "Kashipur Urban Co-operative Bank",
  "Kashmir Mercantile Co-operative Bank",
  "Katihar District Central Co-operative Bank",
  "Kattappana Urban Co-operative Bank",
  "Kaveri Grameena Bank",
  "Kavita Urban Co-operative Bank",
  "KEB Hana Bank",
  "Keonjhar Central Co-operative Bank",
  "Kerala Gramin Bank",
  "Kerala Mercantile Co-operative Bank",
  "Kerala State Co-operative Bank",
  "Keshav Sehkari Bank",
  "Khagaria District Central Co-operative Bank",
  "Khalilabad Nagar d Bank",
  "Khambhat Nagarik Sahakari Bank",
  "Khamgaon Urban Co-operative Bank",
  "Khardah Co-operative Bank",
  "Khattri Co-operative Urban Bank",
  "Kheda People's Co-operative Bank",
  "Khurda Central Co-operative Bank",
  "Kisan Nagari Sahakari Bank Maryadit Parbhani",
  "Kodagu District Co-operative Central Bank",
  "Kodinar Nagrik Sahakari Bank",
  "Kodinar Taluka Co-operative Banking Union",
  "Kodoli Urban Co-operative Bank Kodoli",
  "Kodungallur Town Co-operative Bank",
  "Kohinoor Sahakari Bank Ichalkaranji",
  "Kokan Mercantile Co-operative Bank",
  "Kolar And Chickballapur Dt Co-operative Central Bank",
  "Kolhapur District Central Co-operative Bank",
  "Kolhapur Mahila Sahakari Bank",
  "Kolhapur Urban Co-operative Bank",
  "Kollam District Co-operative Bank",
  "Konark Urban Co-operative Bank",
  "Konoklota Mahila Urban Co-operative Bank",
  "Kookmin Bank",
  "Kopargaon Peoples Co-operative Bank",
  "Koraput Central Co-operative Bank",
  "Kosamba Mercantile Co-operative Bank",
  "Kota Central Co-operative Bank Kota",
  "Kota Mahila Nagrik Sahakari Bank",
  "Kota Nagrik d Bank Kota",
  "Kotak Mahindra Bank",
  "Koteshwara Sahakari Bank Niyamitha",
  "Kottakkal Co-operative Urban Bank",
  "Kottayam District Co-operative Bank",
  "Koylanchal Urban Co-operative Bank",
  "Kozhikode District Co-operative Bank",
  "Kranthi Co-operative Urban Bank",
  "Krishna Bhima Samruddhi Local Area Bank",
  "Krishna District Co-operative Bank",
  "Krishna Mercantile Co-operative Bank",
  "Krishna Sahakari Bank Rethare Bk",
  "Krishnagar City Co-operative Bank",
  "Krungthai Bank",
  "Kukarwada Nagarik Sahakari Bank",
  "Kumbakonam Central Co-operative Bank",
  "Kumbhi Kasari Bank Kuditre",
  "Kurla Nagarik Sahakari Bank",
  "Kurmanchal Nagar Sahakari Bank",
  "Kurukshetra Central Co-operative Bank",
  "Kutch Co-operative Bank",
  "Kuttiady Co-operative Urban Bank",
  "Lakhimpur Urban Co-operative Bank",
  "Lalbaug Co-operative Bank",
  "Langpi Dehangi Rural Bank",
  "Latur District Central Co-operative Bank",
  "Latur Urban Co-operative Bank Latur",
  "Laxmi Co-operative Bank Solapur",
  "Laxmi Mahila Nagrik Sahakari Bank Maryadit",
  "Laxmi Urban Co-operative Bank Latur",
  "Laxmi Vilas Bank",
  "Laxmibai Mahila Nagrik Sahakari Bank Maradit",
  "LIC Employees Co-operative Bank",
  "Liluah Co-operative Bank",
  "Little Kancheepuram Co-operative Urban Bank",
  "Lokmangal Co-operative Bank Solapur",
  "Loknete Dattaji Patil Sahakari Bank",
  "Lokvikas Nagari Sahakari Bank Aurangabad",
  "Lonavala Sahakari Bank",
  "Lord Krishna Bank",
  "Lucknow Urban Co-operative Bank",
  "Ludhiana Central Co-operative Bank",
  "Lunawada Nagarik Sahakari Bank",
  "Lunawada Peoples Co-operative Bank",
  "M.s.Co-operative Bank",
  "Madanapalle Co-operative Town Bank",
  "Madgaum Urban Co-operative Bank",
  "Madheshwari Urban Development Co-operative Bank",
  "Madhya Pradesh Rajya Sahakari Bank Maryadit",
  "Madhyanchal Gramin Bank",
  "Madurai District Central Co-operative Bank",
  "Magadh Central Co-operative Bank",
  "Mahabhairab Co-operative Urban Bank",
  "Mahamedha Urban Co-operative Bank ( Under Rbi Direction)",
  "Mahanagar Co-operative Bank",
  "Mahanagar Co-operative Urban Bank",
  "Mahanagar Nagrik Sahakari Bank Maryadit",
  "Maharaja Co-operative Urban Bank",
  "Maharana Pratap Co-operative Urban Bank",
  "Maharashtra Gramin Bank",
  "Maharashtra Mantralaya & Allied Offices Co-operative Bank",
  "Maharashtra State Co-operative Bank",
  "Mahatma Fule Urban Co-operative Bank,amravati",
  "Mahaveer Co-operative Bank",
  "Mahaveer Co-operative Urban Bank",
  "Mahendragarh Central Co-operative Bank",
  "MAHESH SAHAKARI BANK LTD PUNE",
  "Mahesh Sahakari Bank Pune",
  "Mahesh Urban Co-operative Bank",
  "Mahesh Urban Co-operative Bank Ahmedpur",
  "Mahesh Urban Co-operative Bank Solapur",
  "Mahesh Urbank Co-operative Bank Parli V.",
  "Mahila Co-operative Bak",
  "Mahila Co-operative Nagarik Bank,bharuch",
  "Mahila Nagrik Sahakari Bank Maryadit Mahasamund",
  "Mahila Urban Co-operative Bank",
  "Mahoba Urban Co-operative Bank Mahoba",
  "Mahudha Nagarik Sahakari Bank",
  "Makarpura Industrial Estate Co-operative Bank",
  "Malappuram District Co-operative Bank",
  "Malda District Central Co-operative Bank",
  "Malkapur Urban Co-operative Bank",
  "Malleshwaram Co-operative Bank",
  "Malviya Urban Co-operative Bank",
  "Malwa Gramin Bank",
  "Mandvi Mercantile Co-operative Bank",
  "Mandya District Co-operative Central Bank",
  "Mangaldai Nagar Samabai Bank",
  "Mangalore Catholic Co-operative Bank",
  "Mangalore Co-operative Town Bank",
  "Manipur Rural Bank",
  "Manipur State Co-operative Bank",
  "Manipur Womens Co-operative Bank",
  "Manjeri Co-operative Urban Bank",
  "Manmandir Co-operative Bank",
  "Mann Deshi Mahila Sahakari Bank",
  "Manorama Co-operative Bank Solapur",
  "Mansa Central Co-operative Bank",
  "Mansa Nagarik Sahakari Bank",
  "Mansarovar Urban Co-operative Bank",
  "Mansing Co-operative Bank",
  "Mantha Urban Co-operative Bank",
  "Manvi Pattana Souharda Sahakari Bank Ni",
  "Mapusa Urban Co-operative Bank of Goa",
  "Maratha Co-operative Bank",
  "Marketyard Commercial Co-operative Bank",
  "Mashreq Bank",
  "Mattancherry Mahajanik Co-operative Urban Bank",
  "Mattancherry Sarvajanik Co-operative Bank",
  "Mayani Urban Co-operative Bank",
  "Mayurbhanj Central Co-operative Bank",
  "Md Pawar Peoples Co-operative Bank Urun Islampur",
  "Meenachil East Urban Co-operative Bank",
  "Meghalaya Co-operative Apex Bank",
  "Meghalaya Rural Bank",
  "Meghraj Nagarik Sahakari Bank",
  "Mehmadabad Urban Peoples Co-operative Bank",
  "Mehsana District Central Co-operative Bank",
  "Mehsana Nagarik Sahakari Bank",
  "Mehsana Urban Co-operative Bank",
  "Merchants Liberal Co-operative Bank",
  "Merchants Souharda Sahakara Bank Niyamitha",
  "Merchants Urban Co-operative Bank",
  "Mewar Aanchalik Gramin Bank",
  "Midnapore Peoples Co-operative Bank",
  "Mizoram Co-operative Apex Bank",
  "Mizoram Rural Bank",
  "Mizoram Urban Co-operative Development Bank",
  "Mizuho Bank",
  "Modasa Nagarik Sahakari Bank",
  "Model Co-operative Bank",
  "Modern Co-operative Bank",
  "Moga Central Co-operative Bank",
  "Mogaveera Co-operative Bank",
  "Mohol Urban Co-operative Bank",
  "Moirang Primary Co-operative Bank",
  "Monghyr Jamui Central Co-operative Bank",
  "Motihari Central Co-operative Bank",
  "MUFG Bank",
  "Mugberia Central Co-operative Bank",
  "Muktsar Central Co-operative Bank",
  "Mumbai District Central Co-operative Bank",
  "Municipal Co-operative Bank",
  "Murshidabad District Central Co-operative Bank",
  "Muslim Co-operative Bank",
  "Muzaffarnagar District Co-operative Bank",
  "Muzaffarpur Central Co-operative Bank",
  "Mysore Chamarajanagar District Co-operative Bank",
  "Mysore Silk Cloth Merchants Co-operative Bank",
  "Nabadwip Co-operative Credit Bank",
  "Nabagram Peoples' Co-operative Credit Bank",
  "Nadapuram Co-operative Bank",
  "Nadia District Central Co-operative Bank",
  "Nadiad Peoples Co-operative Bank",
  "Nagaland Rural Bank",
  "Nagaland State Co-operative Bank",
  "Nagar Sahakari Bank",
  "Nagar Sahakari Bank Gorakhpur",
  "Nagar Sahakari Bank Maharajganj",
  "Nagar Urban Co-operative Bank",
  "Nagar Vikas Sahakari Bank",
  "Nagarik Sahakari Bank Bhiwandi",
  "Nagarik Sahakari Bank Maryadit Durg",
  "Nagarik Sahakari Bank Maryadit,jagdalpur",
  "Nagarik Samabay Bank",
  "Nagaur Central Co-operative Bank",
  "Nagaur Urban Co-operative Bank",
  "Nagina Urban Co-operative Bank",
  "Nagnath Urban Co-operative Bank Hingoli",
  "Nagpur Nagarik Sahakari Bank",
  "Nagrik Sahakari Bank",
  "Nagrik Sahakari Bank Indore",
  "Nagrik Sahakari Bank Lucknow",
  "Nagrik Sahakari Bank Maryadit Gwalior",
  "Nagrik Sahakari Bank, Vidisha",
  "Nainital Bank",
  "Nainital District Co-operative Bank",
  "Nakodar Hindu Urban Co-operative Bank",
  "Nalanda Central Co-operative Bank Nalanda",
  "Nalbari Urban Co-operative Bank",
  "Nalgonda Dist. Co-operative Central Bank",
  "Nandani Sahakari Bank",
  "Nanded District Central Co-operative Bank",
  "Nanded Merchants Co-operative Bank Nanded",
  "Nandura Urban Co-operative Bank Nandura",
  "Narmada Jhabua Gramin Bank",
  "Naroda Nagrik Co-operative Bank",
  "Nashik District Girna Sahakari Bank",
  "Nashik District Industrial & Mercantile Co-operative Bank",
  "Nashik Zila Mahila Vikas Sahakari Bank",
  "Nashik Zilha Sarkari & Parishad Karmachari Sb Nmt",
  "Nasik District Central Co-operative Bank",
  "Nasik Merchants Co-operative Bank",
  "Nasik Road Deolali Vyapari Sahakari Bank",
  "Nasik Zila Mahila Sahakari Bank",
  "National Australia Bank",
  "National Bank for Agriculture and Development",
  "National Bank of Abu Dhabi PJSC",
  "National Central Co-operative Bank Bettiah",
  "National Co-operative Bank",
  "National Co-operative Bank Bangalore",
  "National Urban Co-operative Bank",
  "National Urban Co-operative Bank, Pratapgarh",
  "National Urban Co-operative Bank,bahraich",
  "Nav Jeevan Co-operative Bank",
  "Navabharat Co-operative Urban Bank",
  "Naval Dockyard Co-operative Bank",
  "Navanagara Urban Co-operative Bank",
  "Navi Mumbai Co-operative Bank",
  "Navnirman Co-operative Bank",
  "Nawada Central Co-operative Bank",
  "Nawanagar Co-operative Bank",
  "Nawanshahr Central Co-operative Bank",
  "Nayagarh District Central Co-operative Bank",
  "Neela Krishna Co-operative Urban Bank",
  "Nehrunagar Co-operative Bank",
  "New India Co-operative Bank",
  "New Urban Co-operative Bank Rampur",
  "Neyyattinkara Co-operative Urban Bank",
  "Nidhi Co-operative Bank",
  "Nilambur Co-operative Urban Bank",
  "Nileshwar Co-operative Urban Bank",
  "Nilgiris District Central Co-operative Bank",
  "Nilkanth Co-operative Bank",
  "Nirmal Urban Co-operative Bank Nagpur",
  "Nishigandha Sahakari Bank",
  "Nizamabad District Co-operative Central Bank",
  "NKGSB Co-operative Bank",
  "Noble Co-operative Bank",
  "Noida Commercial Co-operative Bak",
  "North East Small Finance Bank",
  "North Malabar Gramin Bank",
  "Northern Railway Multi State Primary Co-operative Bank",
  "NSDL Payments Bank",
  "NSE Clearing Limited",
  "Nutan Nagari Sahakari Bank Ichalkaranji",
  "Nutan Nagarik Sahakari Bank",
  "Odisha Gramya Bank",
  "Odisha State Co-operative Bank",
  "Ojhar Merchant's Co-operative Bank",
  "Omkar Nagreeya Sahakari Bank",
  "Oriental Bank of Commerce",
  "Osmanabad District Central Co-operative Bank",
  "Osmanabad Janata Sahakari Bank",
  "Ottapalam Co-operative Urban Bank",
  "P. D. Patilsaheb Sahakari Bank",
  "Pachora Peoples Co-operative Bank",
  "Padmashri Dr. Vitthalrao Vikhe Patil Co-operative Bank",
  "Padra Nagar Nagrik Sahakari Bank",
  "Palakkad District Co-operative Bank",
  "Palamoor Co-operative Urban Bank",
  "Pali Central Co-operative Bank",
  "Pali Urban Co-operative Bank",
  "Pallavan Grama Bank",
  "Palus Sahakari Bank",
  "Panchkula Central Co-operative Bank",
  "Panchkula Urban Co-operative Bank Lmited",
  "Panchmahal District Co-operative Bank",
  "Panchsheel Mercantile Co-operative Bank",
  "Pandharpur Urban Co-operative Bank",
  "Pandyan Grama Bank",
  "Panihati Co-operative Bank",
  "Panipat Central Co-operative Bank",
  "Panipat Urban Co-operative Bank",
  "Paraspar Sahayak Co-operative Bank",
  "Parbhani District Central Co-operative Bank",
  "Parshwanath Co-operative Bank",
  "Parwanoo Urban Co-operative Bank",
  "Paschim Banga Gramin Bank",
  "Patan Co-operative Bank",
  "Patan Nagarik Sahakari Bank",
  "Patan Urban Co-operative Bank Patan",
  "Pathanmthitta District Co-operative Bank",
  "Patiala Central Co-operative Bank",
  "Patliputra Central Co-operative Bank",
  "Pavana Sahakari Bank",
  "Payangadi Urban Co-operative Bank",
  "Paytm Payments Bank",
  "Payyoli Co-operative Urban Bank",
  "People's Urban Co-operative Bank",
  "Peoples' Co-operative Bank",
  "Pimpalgaon Merchants Co-operative Bank",
  "Pimpri Chinchwad Sahakari Bank Maryadit,pimpri",
  "Pithoragarh Zila Sahakari Bank",
  "Pochampally Co-operative Urban Bank",
  "Pondicherry State Co-operative Bank",
  "Poornawadi Nagrik Sahakari Bank",
  "Pragathi Co-operative Bank, Bangalore",
  "Pragathi Krishna Gramin Bank",
  "Pragati Co-operative Bank, Thara",
  "Pragati Mahila Nagrik Sahakari Bank Bhilai",
  "Pragati Sahakari Bank",
  "Prakasam District Co-operative Central Bank",
  "Prathama Bank",
  "Prathama UP Gramin Bank",
  "Prathamik Shikshak Sahakari Bank",
  "Pravara Sahakari Bank",
  "Prerana Co-operative Bank",
  "Prime Co-operative Bank",
  "Priyadarshani Nagari Sahakari Bank Jalna.",
  "Priyadarshani Urban Co-operative Bank",
  "Proddatur Co-operative Town Bank",
  "Progressive Co-operative Bank",
  "Progressive Mercantile Co-operative Bank",
  "Progressive Urban Co-operative Bank",
  "PT Bank Maybank Indonesia TBK",
  "Pudukottai District Central Co-operative Bank",
  "Puduvai Bharathiar Grama Bank",
  "Pune Cantonment Sahakari Bank",
  "Pune District Central Co-operative Bank",
  "Pune Merchant's Co-operative Bank",
  "Pune People's Co-operative Bank",
  "Pune Urban Co-operative Bank",
  "Punjab & Maharashtra Co-operative Bank",
  "Punjab & Sind Bank",
  "Punjab Gramin Bank",
  "Punjab National Bank",
  "Punjab State Co-operative Bank",
  "Purasawalkam Co-operative Bank",
  "Puri Urban Co-operative Bank",
  "Purnea District Central Co-operative Bank",
  "Purulia Central Co-operative Bank",
  "Purvanchal Co-operative Bank Gazipur",
  "Purvanchal Gramin Bank",
  "Pusad Urban Co-operative Bank",
  "Qatar National Bank",
  "Quilon Co-operative Urban Bank",
  "Rabobank International",
  "Radhasoami Urban Co-operative Bank",
  "Raichur District Central Co-operative Bank",
  "Raigad District Central Co-operative Bank",
  "Raigad Sahakari Bank",
  "Raiganj Central Co-operative Bank",
  "Railway Employees Co-operative Bank",
  "Railway Employees Co-operative Banking Society",
  "Raipur Urban Mercantile Co-operative Bank",
  "Raj Laxmi Mahila Urban Co-operative Bank Jaipur",
  "Rajadhani Co-operative Urban Bank",
  "Rajajinagar Co-operative Bank",
  "Rajapur Urban Co-operative Bank",
  "Rajarambapu Sahakari Bank",
  "Rajarambapu Sahakari Bank Peth",
  "Rajarshi Shahu Govt Servants Co-operative Bank Kolh",
  "Rajarshi Shahu Sahakari Bank",
  "Rajasthan Marudhara Gramin Bank",
  "Rajasthan State Co-operative Bank",
  "Rajasthan Urban Co-operative Bank",
  "Rajdhani Nagar Sahakari Bank",
  "Rajgurunagar Sahakari Bank",
  "Rajkot Commercial Co-operative Bank",
  "Rajkot Nagarik Sahakari Bank",
  "Rajkot Peoples Co-operative Bank",
  "Rajlaxmi Urban Co-operative Bank",
  "Rajnandgaon District Central Co-operative Bank",
  "Rajpipla Nagarik Sahakari Bank",
  "Rajputana Mahila Urban Co-operative Bak",
  "Rajsamand Urban Co-operative Bank",
  "Ramanathapuram District Central Co-operative Bank",
  "Ramgarhia Co-operative Bank",
  "Rampur Zila Sahakari Bank",
  "Ramrajya Sahakari Bank",
  "Ranchi Khunti Central Co-operative Bank",
  "Rander Peoples Co-operative Bank",
  "Ranga Reddy Co-operative Urban Bank",
  "Rani Channamma Mahila Sahakari Bank",
  "Raniganj Co-operative Bank",
  "Ranilaxmibai Urban Co-operative Bank",
  "Ranuj Nagrik Sahakari Bank",
  "Ratnagiri District Central Co-operative Bank",
  "Ravi Commercial Urban Co-operative Bank",
  "RBL Bank",
  "Rendal Sahakari Bank Rendal",
  "Reserve Bank Employees Co-operative Bank",
  "Reserve Bank of India",
  "Reserve Bank Of India",
  "Rewari Central Co-operative Bank",
  "Rohika Central Co-operative Bank Madhubani",
  "Rohtak Central Co-operative Bank",
  "Ropar Central Co-operative Bank",
  "Royal Bank of Scotland N.V.",
  "S S L S A Kurundwad Urban Bank",
  "S.A.S Nagar Central Co-operative Bank",
  "S.S.K Co-operative Bank",
  "Sabarkantha District Central Co-operative Bank",
  "Sadguru Gahininath Urban Co-operative Bank Akluj",
  "Sadguru Nagrik Sahakari Bank Maryadit",
  "Sadhana Sahakari Bank",
  "Sadhana Sahakari Bank Pune",
  "Sahebrao Deshmukh Co-operative Bank",
  "Sahyadri Sahakari Bank",
  "Saibaba Nagari Sahakari Bank",
  "Saidapet Co-operative Urban Bank",
  "Salal Sarvodaya Nagarik Sahakari Bank",
  "Salem District Central Co-operative Bank",
  "Samarth Sahakari Bank",
  "Samastipur District Central Co-operative Bank",
  "Samata Co-operative Development Bank",
  "Samata Sahakari Bank",
  "Sambalpur District Co-operative Central Bank",
  "Sampada Sahakari Bank",
  "Samruddhi Co-operative Bank",
  "Sandur Pattana Souharda Sahakari Bank Niyamitha",
  "Sangamner Merchants Co-operative Bank",
  "Sanghamitra Co-operative Urban Bank",
  "Sangli District Central Co-operative Bank",
  "Sangli Sahakari Bank",
  "Sangli Urban Co-operative Bank",
  "Sangrur Central Co-operative Bank",
  "Sankheda Nagarik Sahakari Bank",
  "Sanmati Sahakari Bank",
  "Sanmitra Sahakari Bank",
  "Sanmitra Urban Co-operative Bank",
  "Sant Sopankaka Sahakari Bank",
  "Santragachi Co-operative Bank",
  "Saptagiri Grameena Bank",
  "Sarakari Naukarara Sahakari Bank Niyamt Vijayapura",
  "Sarangpur Co-operative Bank",
  "Saraspur Nagarik Co-operative Bank",
  "Saraspur Nagrik Co-operative Bank",
  "Saraswat Co-operative Bank",
  "Saraswati Sahakari Bank",
  "Sardar Bhiladwala Pardi People's Co-operative Bank",
  "Sardar Vallabhbhai Sahakari Bank",
  "Sardarganj Mercantile Co-operative Bank",
  "Sardargunj Mercantile Co-operative Bank Patan",
  "Sarjeraodada Naik Shirala Sahakari Bank",
  "Sarva Haryana Gramin Bank",
  "Sarvodaya Co-operative Bank Mumbai",
  "Sarvodaya Commerical Co-operative Bank",
  "Sarvodaya Nagrik Sahakari Bank",
  "Sarvodaya Sahakari Bank",
  "Sasaram Bhabhua Central Co-operative Bank",
  "Satana Merchants Co-operative Bank, Satana",
  "Satara District Central Co-operative Bank",
  "Satara Sahakari Bank",
  "Satara Shakari Bank",
  "Sathamba Peoples Co-operative Bank",
  "Saurashtra Co-operative Bank",
  "Saurashtra Gramin Bank",
  "Sawai Madhopur Kendriya Sahakari Bank",
  "Sawai Madhopur Urban Co-operative Bank",
  "SBER Bank",
  "SBM Bank",
  "Secunderabad Co-operative Urban Bank",
  "Secunderabad Mercantile Co-operative Urban Bank",
  "Sehore Nagrik Sahakari Bank Sehore",
  "Seva Vikas Co-operative Bank",
  "Sevalia Urban Co-operative Bank",
  "Shankar Nagari Sahakari Bank",
  "Shankarrao Mohite Patil Sahakri Bank",
  "Sharad Nagari Sahakari Bank",
  "Sharad Sahakari Bank",
  "Shiggaon Urban Co-operative Bank",
  "Shihori Nagarik Sahakari Bank",
  "Shikshak Sahakari Bank",
  "Shillong Co-operative Urban Bank",
  "Shimla Urban Co-operative Bank",
  "Shimoga Arecanut Mandy Merchants Co-operative Bank",
  "Shimoga District Co-operative Central Bank",
  "Shinhan Bank",
  "Shirpur Peoples Co-operative Bank",
  "Shivaji Nagari Sahakari Bank",
  "Shivajirao Bhosale Sahakari Bank",
  "Shivalik Small Finance Bank",
  "Shivdaulat Sahakari Bank",
  "Shoranur Co-operative Urban Bank",
  "Shramik Nagrik Sahakari Bank",
  "Shree Balaji Urban Co-operative Bank",
  "Shree Basaveshwar Co-operative Bank",
  "Shree Basaveshwar Urban Co-operative Bank",
  "Shree Bharat Co-operative Bank",
  "Shree Bhavnagar Nagrik Sahakari Bank",
  "Shree Botad Mercantile Co-operative Bank",
  "Shree Co-operative Bank",
  "Shree Dharati Co-operative Bank",
  "Shree Kadi Nagarik Sahakari Bank",
  "Shree Laxmi Co-operative Bank",
  "Shree Mahalaxmi Mercantile Co-operative Bank",
  "Shree Mahalaxmi Urban Co-operative Credit Bank",
  "Shree Mahavir Sahakari Bank",
  "Shree Mahesh Co-operative Bank Nashik",
  "Shree Mahuva Nagrik Sahakari Bank",
  "Shree Panchganga Nagari Sahakari Bank",
  "Shree Parswanath Co-operative Bank",
  "Shree Samarth Sahakari Bank Nashik",
  "Shree Sharada Sahakari Bank",
  "Shree Thyagaraja Co-operative Bank",
  "Shree Vardhaman Sahakari Bank",
  "Shree Veershaiv Co-operative Bank",
  "Shree Warana Sahakari Bank",
  "Shri Adinath Co-operative Bank",
  "Shri Arihant Co-operative Bank",
  "Shri Basaveshwar Sahakari Bank Nyt.bagalkot",
  "Shri Bharat Urban Co-operative Bank Jaysingpur",
  "Shri Chhani Nagrik Sahakari Bank",
  "Shri Chhatrapati Rajashri Shahu Urban Co-operative Bank",
  "Shri D T Patil Co-operative Bank",
  "Shri Ganesh Sahakari Bank",
  "Shri Kanyaka Nagari Sahakari Bank",
  "Shri Mahalaxmi Co-operative Bank Kolhapur",
  "Shri Mahavir Urban Co-operative Bank",
  "Shri Mahila Sewa Sahakari Bank",
  "Shri Rajkot District Co-operative Bank",
  "Shri Rukmini Sahakari Bank",
  "Shri Veershaiv Co-operative Bank",
  "Shri Vijay Mahantesh Co-operative Bank",
  "Shri Vinayak Sahakari Bank",
  "Shrikrishna Co-operative Bank",
  "Shrimant Malojiraje Sahakari Bank",
  "Shripatraodada Sahakari Bank",
  "Shriram Urban Co-operative Bank",
  "Shubhalakshmi Mahila Co-operative Bank",
  "Shushruti Souharda Sahakara Bank Niyamita",
  "Siddheshwar Urban Co-operative Bank Maryadit Sillod",
  "Siddhi Co-operative Bank",
  "Sihor Mercantile Co-operative Bank",
  "Sihor Nagarik Sahakari Bank",
  "Sikar Kendriya Sahakari Bank",
  "Sikar Urban Co-operative Bank",
  "Sikkim State Co-operative Bank",
  "Sind Co-operative Urban Bank",
  "Sindhudurg District Central Co-operative Bank",
  "Singhbhum District Central Co-operative Bank",
  "Sir M Visvesvaraya Co-operative Bank",
  "Sircilla Co-operative Urban Bank",
  "Sirohi Central Co-operative Bank",
  "Sirsa Central Co-operative Bank",
  "Sirsi Urban Sahakari Bank",
  "Sitamarhi Central Co-operative Bank",
  "Sivagangai District Central Co-operative Bank",
  "Siwan Central Co-operative Bank",
  "Small Industries Development Bank Of India",
  "Smriti Nagrik Sahakari Bank",
  "Social Co-operative Bank",
  "Societe Generale",
  "Solapur District Central Co-operative Bank",
  "Solapur Janata Sahakari Bank",
  "Solapur Siddheshwar Sahakari Bank",
  "Solapur Social Urban Co-operative Bank",
  "Sonali Bank",
  "Sonbhadra Nagar Sahakari Bank",
  "Sonepat Central Co-operative Bank",
  "Sonepat Urban Co-operative Bank",
  "Soubhagya Mahila Souhardha Sahakari Bank",
  "South Canara District Central Co-operative Bank",
  "South Indian Bank",
  "Sree Charan Souhardha Co-operative Bank",
  "Sree Narayana Guru Co-operative Bank",
  "Sree Subramanyeswara Co-operative Bank",
  "Sreenidhi Souharda Sahakari Bank Niyamitha",
  "Sri Banashankari Mahila Co-operative Bank",
  "Sri Basaveshwar Pattana Sahakari Bank",
  "Sri Channabasavaswamy Souhardha Pattana Sahak Bank",
  "Sri Kannikaparameswari Co-operative Bank",
  "Sri Potti Sriramulu Nellore Dccb",
  "Sri Rama Co-operative Bank",
  "Sri Sudha Co-operative Bank",
  "Sri Vasavamba Co-operative Bank",
  "Standard Chartered Bank",
  "State Bank of Bikaner and Jaipur",
  "State Bank of Hyderabad",
  "State Bank of India",
  "State Bank of Mysore",
  "State Bank of Patiala",
  "State Bank of Travancore",
  "State Transport Co-operative Bank",
  "Sterling Urban Co-operative Bank",
  "Subhadra Local Area Bank",
  "Suco Souharda Sahakari Bank",
  "Sudha Co-operative Urban Bank",
  "Sulaimani Co-operative Bank",
  "Sultan's Bathery Co-operative Urban Bank",
  "Sumerpur Mercantile Urban Co-operative Bank",
  "Sumitomo Mitsui Banking Corporation",
  "Sundargarh District Central Co-operative Bank",
  "Sundarlal Sawaji Urban Co-operative Bank",
  "Surat District Co-operative Bank",
  "Surat Mercantile Co-operative Bank",
  "Surat National Co-operative Bank",
  "Surat People's Co-operative Bank",
  "Surendranagar District Co-operative Bank",
  "Suryoday Small Finance Bank",
  "Sutex Co-operative Bank",
  "Sutlej Gramin Bank",
  "Suvarnayug Sahakari Bank",
  "SVC Co-operative Bank",
  "Syndicate Bank",
  "Taliparamba Co-operative Urban Bank",
  "Tamilnad Mercantile Bank",
  "Tamilnadu Circle Postal Co-operative Bank",
  "Tamilnadu Industrial Co-operative Bank",
  "Tamilnadu State Apex Co-operative Bank",
  "Tamluk-ghatal Central Co-operative Bank",
  "Tapindu Urban Co-operative Bank",
  "Tarn Taran Central Co-operative Bank",
  "Tasgaon Urban Co-operative Banktasgaon",
  "Tehri Garhwal Zila Sahakari Bank",
  "TELANGANA GRAMEENA BANK",
  "Telangana State Co-operative Apex Bank",
  "Textile Co-operative Bank",
  "Textile Co-operative Bank of Surat",
  "Textile Manufacturers Co-operative Bank",
  "Textile Traders Co-operative Bank",
  "Thane Bharat Sahakari Bank",
  "Thane District Central Co-operative Bank",
  "Thanjavur Central Co-operative Bank",
  "THE BURDWAN CENTRAL CO OPERATIVE BANK LTD",
  "The Malad Sahakari Bank",
  "The Union Co-operative Bank Mahinagar",
  "The Vijay Co-operative Bank",
  "Thiruvananthapuram District Co-operative Bank",
  "Thiruvannamalai District Central Co-operative Bank",
  "Thodupuzha Urban Co-operative Bank",
  "Thoothukudi District Central Co-operative Bank",
  "Thrissur District Co-operative Bank",
  "Tiruchirapalli Dist. Cent Co-operative Bank",
  "Tirunelveli District Central Co-operative Bank",
  "Tirupati Urban Co-operative Bank",
  "Tirur Urban Co-operative Bank",
  "Tiruvallur Co-operative Urban Bank",
  "TJSB Sahakari Bank",
  "Town Co-operative Bank Hoskote",
  "Transport Co-operative Bank",
  "Trichur Urban Co-operative Bank",
  "Tripura Gramin Bank",
  "Tripura State Co-operative Bank",
  "Trivandrum Co-operative Urban Bank",
  "Tumkur District Central Bank",
  "Tumkur Grain Merchant's Co-operative Bank",
  "Tura Urban Co-operative Bank",
  "UCO Bank",
  "Udaipur Central Co-operative Bank",
  "Udaipur Mahila Samridhi Urban Co-operative Bank",
  "Udaipur Mahila Urban Co-operative Bank",
  "Udaipur Urban Co-operative Bank",
  "Udham Singh Nagar District Co-operative Bank",
  "Udupi Co-operative Town Bank",
  "Ujjivan Small Finance Bank",
  "Uma Co-operative Bank",
  "Umiya Urban Co-operative Bank",
  "Umreth Urban Co-operative Bank",
  "Una Peoples Co-operative Bank",
  "Unava Nagrik Sahakari Bank",
  "Union Bank of India",
  "Union Co-operative Bank",
  "United Bank of India",
  "United Co-operative Bank",
  "United India Co-operative Bank",
  "United Mercantile Co-operative Bank",
  "United Overseas Bank",
  "United Puri Nimapara Central Bank",
  "Unity Small finance Bank Limited",
  "Universal Co-operative Urban Bank",
  "Unjha Nagarik Sahakari Bank",
  "Urban Co-operative Bank Bareilly",
  "Urban Co-operative Bank Basti",
  "Urban Co-operative Bank Budaun",
  "Urban Co-operative Bank Dehradun",
  "Urban Co-operative Bank Dharangaon",
  "Urban Co-operative Bank Mainpuri",
  "Urban Co-operative Bank No 1758 Perinthalmanna",
  "Urban Co-operative Bank Perinthalmanna",
  "Urban Co-operative Bank Rourkela",
  "Urban Co-operative Bank Saharanpur",
  "Urban Co-operative Bank Siddharthnagar",
  "Utkal Co-operative Banking Society",
  "Utkal Grameen Bank",
  "Utkarsh Small Finance Bank",
  "Uttar Bihar Gramin Bank",
  "Uttar Pradesh Co-operative Bank",
  "Uttarakhand Gramin Bank",
  "Uttarakhand State Co-operative Bank",
  "UTTARAKHAND STATE COOPERATIVE BANK LIMITED",
  "Uttarbanga Kshetriya Gramin Bank",
  "Uttarkashi Zila Sahakari Bank",
  "Uttarpara Co-operative Bank",
  "Uttarsanda Peoples Co-operative Bank Uttarsanda",
  "Uttrakhand Co-operative Bank",
  "Vaidyanath Urban Co-operative Bank",
  "Vaijapur Merchants Co-operative Bank",
  "Vaish Co-operative Adarsh Bank",
  "Vaish Co-operative New Bank",
  "Vaishali District Central Co-operative Bank",
  "Vaishali Shahari Vikas Co-operative Bank",
  "Vaishya Nagari Sahakari Bank",
  "Vaishya Sahakari Bank Mumbai",
  "Vallabh Vidyanagar Commercial Bank",
  "Valmiki Urban Co-operative Bank",
  "Valsad District Central Co-operative Bank",
  "Varachha Co-operative Bank",
  "Vardhaman (mahila) Co-operative Urban Bank",
  "Vardhaman Co-operative Bank",
  "Vasai Janata Sahakari Bank",
  "Vasai Vikas Sahakari Bank",
  "Veerashaiva Sahakari Bank",
  "Vellala Co-operative Bank",
  "Vellore District Central Co-operative Bank",
  "Veraval Mercantile Co-operative Bank",
  "Veraval Peoples Co-operative Bank",
  "Vidarbha Merchants Urban Co-operative Bank",
  "Vidharbha Kokan Gramin Bank",
  "Vidya Sahakari Bank",
  "Vidyanand Co-operative Bank",
  "Vidyasagar Central Co-operative Bank",
  "Vijay Co-operative Bank",
  "Vijay Commercial Co-operative Bank",
  "Vijaya Bank",
  "Vikas Sahakari Bank Solapur",
  "Vikas Souharda Co-operative Bank",
  "Vikramaditya Nagrik Sahakari Bank",
  "Villupuram District Central Co-operative Bank",
  "Vima Kamgar Co-operative Bank",
  "Viramgam Mercantile Co-operative Bank",
  "Virudhunagar District Central Co-operative Bank",
  "Visakhapatnam Co-operative Bank",
  "Vishwas Co-operative Bank",
  "Vishweshwar Sahakari Bank",
  "Vita Merchants Co-operative Bank",
  "Vita Urban Co-operative Bank",
  "Vivekanand Nagrik Sahakari Bank Mydt",
  "Vyapari Sahakari Bank Maryadit Solapur",
  "Vyaparik Audhyogik Sahakari Bank",
  "Vyavsayak Sahakari Bank",
  "Waghodia Urban Co-operative Bank",
  "Wai Urban Co-operative Bank",
  "Wana Nagirik Sahakari Bank",
  "Warangal District Co-operative Central Bank",
  "Warangal Urban Co-operative Bank",
  "Wardha Zilla Parishad Emp Urban Co-operative Bank",
  "Wardhaman Urban Co-operative Bank Nagpur",
  "Washim Urban Co-operative Bank.",
  "Wayanad District Co-operative Bank",
  "West Bengal State Co-operative Bank",
  "Westpac Banking Corporation",
  "Women's Co-operative Bank",
  "Woori Bank",
  "Yadagiri Lakshmi Narsimha Swamy Co-operative Urban Bank",
  "Yamuna Nagar Central Co-operative Bank",
  "Yashwant Co-operative Bank",
  "Yavatmal District Central Co-operative Bank",
  "Yavatmal Mahila Sahakari Bank",
  "Yavatmal Urban Co-operative Bank",
  "Yes Bank",
  "Yeshwant Nagari Sahakari Bank",
  "Youth Development Co-operative Bank",
  "Zila Sahakari Bank Bareilly",
  "Zila Sahakari Bank Bijnor",
  "Zila Sahakari Bank Bulandshahar",
  "Zila Sahakari Bank Garhwal Kotdwar",
  "Zila Sahakari Bank Ghaziabad",
  "Zila Sahakari Bank Gorakhpur",
  "Zila Sahakari Bank Haridwar",
  "Zila Sahakari Bank Jhansi",
  "Zila Sahakari Bank Kanpur",
  "Zila Sahakari Bank Lakhimpur Kheri",
  "Zila Sahakari Bank Lalitpur",
  "Zila Sahakari Bank Lucknow",
  "Zila Sahakari Bank Mathura",
  "Zila Sahakari Bank Mau",
  "Zila Sahakari Bank Meerut",
  "Zila Sahakari Bank Mirzapur",
  "Zila Sahakari Bank Moradabad",
  "Zila Sahakari Bank Unnao",
  "Zoroastrian Co-operative Bank"
];
